import Client from './client';
import BuildingMeters from './building-meters';
import TypeUtils from '@/helpers/type-utils';

export default class ClientBuildings {

  client: Client;
  buildingMeters: BuildingMeters[];

  static map(client: Client, buildingMeters: BuildingMeters[]): ClientBuildings | null {

    if (client == null) {
      return null;
    }

    const clientBuildings = new ClientBuildings();

    clientBuildings.client = Client.map(client);
    clientBuildings.buildingMeters = TypeUtils.hasArrayOrDefault(buildingMeters, []);

    return clientBuildings;
  }
}
